/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const SessionDialogSx: Record<string, SxProps<Theme>> = {
	dialog: {
		borderRadius: '0',
		maxWidth: 'fit-content',
		minWidth: '288px',
		maxHeight: '90%',
		minHeight: '100px',
	},
	title: {
		p: '10px',
		display: 'flex',
		justifyContent: 'center',
	},
	divider: {
		borderColor: 'grey.50',
	},
	titleText: {
		alignSelf: 'center',
		fontWeight: OpenSansFontWeights.light,
		color: 'grey.500',
	},
	closeIcon: {
		position: 'absolute',
		right: '10px',
		color: 'grey.100',
		cursor: 'pointer',
		'&:hover': {
			color: 'primary.main',
		},
		fontSize: '20px',
	},
	content: {
		p: '0',
		maxWidth: (theme: Theme) => theme.breakpoints.values.xl,
	},
};
